import { generateId } from "./../../ricos-content";
import { TIPTAP_FIGURE_TYPE, TIPTAP_VIDEO_TYPE } from "./../../ricos-content/consts";
import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const videoConverter = {
  toPm: {
    types: [Node_Type.VIDEO],
    // @ts-ignore $TSFixMe
    convert: (node, visit) => {
      const fallbackCaption = {
        id: generateId(),
        type: Node_Type.CAPTION,
        nodes: []
      };
      return {
        type: TIPTAP_FIGURE_TYPE,
        attrs: {
          id: generateId()
        },
        content: [
          {
            type: TIPTAP_VIDEO_TYPE,
            attrs: {
              ...node.videoData,
              id: node.id
            }
          },
          ...visit(node.nodes?.length > 0 ? node : { ...node, nodes: [fallbackCaption] })
        ]
      };
    }
  },
  fromPm: {
    types: [TIPTAP_FIGURE_TYPE, TIPTAP_VIDEO_TYPE],
    convert: (node, visit) => {
      if (node.type === TIPTAP_VIDEO_TYPE) {
        return void 0;
      }
      const videoNode = node.content?.find(({ type }) => type === TIPTAP_VIDEO_TYPE);
      if (!videoNode) {
        return void 0;
      }
      const { id, ...data } = videoNode?.attrs || {};
      const [captionNode] = visit?.(node) ?? [];
      const { spoiler, ...rest } = data.containerData || {};
      const containerData = {
        ...rest,
        ...spoiler?.enabled ? { spoiler: { ...spoiler } } : {}
      };
      return {
        type: Node_Type.VIDEO,
        id: id ?? generateId(),
        nodes: captionNode?.nodes[0]?.textData?.text ? [captionNode] : [],
        videoData: {
          ...data,
          disableDownload: data.disableDownload || void 0,
          containerData: Object.keys(containerData).length ? containerData : void 0
        }
      };
    }
  }
};
export {
  videoConverter
};
//# sourceMappingURL=video-converter.js.map
